import {slideUp, slideDown} from "./slide";

export default class Tab{
    
    constructor(el){
        this.wrap = el;
        this.tabs = el.querySelectorAll('.tab');

        this.tabsNavBtns = el.querySelectorAll('.tabs__nav-btn');
        
        this.init();
    }
    
    init(){
        this.tabsNavBtns.forEach((btn) =>{
            let target = btn.dataset.target;
            let tab = this.wrap.querySelector(`.tab[data-target="${target}"]`);
            btn.addEventListener('click', () => {
                this.tabs.forEach((tempTab) => {
                    if (tempTab !== tab){
                        tempTab.classList.remove('active');
                    }
                });
                this.tabsNavBtns.forEach((tempBtn) => {
                    if (tempBtn !== tab){
                        tempBtn.classList.remove('active');
                    }
                });
                btn.classList.add('active');
                tab.classList.add('active');
            });
        });
        this.tabs.forEach((tab) =>{
            const categoryBtns = tab.querySelectorAll('.tab__category-btn');
            const tabContents = tab.querySelectorAll('.tab__content')
            categoryBtns.forEach((btn) =>{
                let target = btn.dataset.target;
                let tabContent = this.wrap.querySelector(`.tab__content[data-target="${target}"]`);
                btn.addEventListener('click', () => {
                    tabContents.forEach((tempTab) => {
                        if (tempTab !== tabContent){
                            tempTab.classList.remove('active');
                        }
                    });
                    categoryBtns.forEach((tempBtn) => {
                        if (tempBtn !== tabContent){
                            tempBtn.classList.remove('active');
                        }
                    });
                    btn.classList.add('active');
                    tabContent.classList.add('active');
                });
            });
        });
            // let header = accordion.querySelector('.accordion__item-header');
            // let content = accordion.querySelector('.accordion__item-content');

            // header.addEventListener('click', () => {
            //     if (!this.animating){
            //         this.animating = true;
            //         if (this.openedAccordion){
            //             this.openedAccordion.element.classList.remove('active');
            //             slideUp(this.openedAccordion.content, 500, () => { this.animating = false });
            //             if (this.openedAccordion.element == accordion){
            //                 this.openedAccordion = null;
            //                 return;
            //             }
            //             this.openedAccordion = null;
            //         }

            //         accordion.classList.add('active');
            //         slideDown(content, 500, () => { this.animating = false });

            //         this.openedAccordion = {
            //             'element' : accordion,
            //             'header' : header,
            //             'content' : content,
            //         };
            //     }
            // });
        // });
    }
}